







import { Component, mixins } from 'nuxt-property-decorator'
import NProgress from 'nprogress'
import MixinGeneral from '~/assets/mixins/general'
import 'nprogress/nprogress.css'
@Component({
  components: {
    ComponentLoadingSpinner: () => import('~/components/loading/spinner.vue'),
  },
})
export default class ComponentLoadingPage extends mixins(MixinGeneral) {
  private loading = false

  private created(): void {
    NProgress.configure({ showSpinner: false })
  }

  private start() {
    if (this.isNativePlatform) {
      this.loading = true
    } else {
      NProgress.start()
    }
  }

  private finish() {
    if (this.isNativePlatform) {
      this.loading = false
    } else {
      NProgress.done()
    }
  }
}
